
import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Paper,
    Typography,
    Button,
    DialogTitle,
    Grid,
    InputBase,
    InputAdornment
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';
import { dictionary, getActiveDirectory, getActiveDirectoryDelete } from 'mdoc/admin/axios'
import CustomizedTable from 'mdoc/utils/table'
import Dialog from 'mdoc/utils/myDialog'
import Toast from 'mdoc/utils/toast';
import * as config from 'mdoc/admin/axios/config'

const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        margin: theme.spacing.unit
    },
    link: {
        color: '#2196f3',
        textDecoration: 'none'
    },
    title: {
        marginLeft: '-20px'
    },
    inputRoot: {
        display: 'flex',
        alignItems: 'center',
        boxShadow: 'none',
        border: '1px solid #ced4da',
        borderRadius: '0px',
        height: '29px',
        marginRight: '10px'
    },
    input: {
        marginLeft: 8,
        flex: 1,
    },
});


class ActiveDirectory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRowKeys: [],
            data: [
            ],
            dictWord: {
                group_id: '',
                sever_name: '',
                url: '',
                valid_flg: '',
                last_acquisition_date: '',
                connection_test: '',
                user_id: '',
                management: '',
                search: '',
                add_record: '',
                modify_record: '',
                delete_record: '',
                valid: '',
                invalid: '',
                confirmation: '',
                msg_confirm_really_delete: '',
                domain_node: '',
                yes: '',
                cancel: ''
            },
            formData: {
                serverName: {
                    value: '',
                    error: false,
                    errorMsg: '',
                    disabled: false
                },
                userId: {
                    value: '',
                    error: false,
                    errorMsg: '',
                    disabled: false
                },
            },
            loading: false,
            permissions: [],
            openStatus: config['VALID'],
            pagination: {
                pageNumber: 1,
                pageSize: 25,
                page: 1,
                count: 0,
                sidx: '',
                sord: ''
            },
            open: false,
            dialogOpen: false,
            id: '',
        };
    }
    componentWillMount() {
        this.start(this.state);
    }

    start = (state) => {
        this.setState({ loading: true });
        let dict = {}
        dictionary(state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,
            })
        })
    }
    fetch = (params = {}) => {
        let formData = this.state.formData;
        this.setState({ loading: true })
        getActiveDirectory({
            serverName: formData.serverName.value,
            serverUserId: formData.userId.value,
            ...params,
        }).then((data) => {
            const pagination = { ...this.state.pagination, ...params }
            pagination.count = data.count;
            this.setState({
                loading: false,
                data: data.results.mstExternalServerSetting !== undefined ? data.results.mstExternalServerSetting : [],
                pagination: pagination,
            })
        }).catch(error => {
            this.setState({
                data: [],
                pagination: {
                    pageNumber: 1,
                    pageSize: 25,
                    page: 1,
                    count: 0,
                    sidx: '',
                    sord: ''
                },
            })
            Toast.info(error)
        })
    }
    searchClick = () => {
        this.fetch({
            pageNumber: this.state.pagination.page,
            pageSize: this.state.pagination.pageSize,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        });
    }
    handleTableChange = (event, pagination) => {
        this.fetch({
            pageNumber: pagination.page,
            pageSize: pagination.rowsPerPage,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        })
    }

    handleSubmit = (adminId) => (event) => {
        this.setState({
            id: adminId,
            dialogOpen: true
        });
    }
    handleChange = (filed) => event => {
        let formData = this.state.formData;
        formData[filed] = Object.assign(this.state['formData'][filed], { value: event.target.value });
        this.setState({
            formData: formData
        });
    };
    dialogHandleOK = (event) => {
        getActiveDirectoryDelete(this.state.id).then(res => {
            window.location.reload()
        }).catch(function (error) {
            Toast.error(error);
        })
    }

    handleTableSort = (event, property) => {
        const sidx = property;
        let sord = 'desc';

        let pagination = this.state.pagination;
        if (pagination.sidx === property && pagination.sord === 'desc') {
            sord = 'asc';
        }
        pagination['sord'] = sord;
        pagination['sidx'] = sidx;
        this.setState({
            pagination: pagination
        });
        this.fetch({
            pageNumber: this.state.pagination.pageNumber,
            pageSize: this.state.pagination.pageSize,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        })
    };

    dialogHandleClose = () => {
        this.setState({
            dialogOpen: false
        });
    }

    render() {
        const { classes } = this.props;
        const { dictWord } = this.state;
        const columns = [
            {
                title: dictWord.sever_name,
                dataIndex: 'serverName',
                sortIndex: 'serverName',
                sorter: true,
                width: '120px'
            }, {
                title: dictWord.url,
                dataIndex: 'serverBaseUrl',
                width: '120px'
            }, {
                title: dictWord.user_id,
                dataIndex: 'serverUserId',
                sortIndex: 'serverUserId',
                sorter: true,
                width: '120px'
            }, {
                title: dictWord.domain_node,
                dataIndex: 'domainNode',
                sortIndex: 'domainNode',
                sorter: true,
                width: '120px'
            }
            , {
                title: dictWord.valid_flg,
                dataIndex: 'validFlg',
                width: '152px',
                render: (text, record) => {
                    if (record['validFlg'] === "VALID") {
                        return this.state.dictWord[this.state.openStatus[1]];
                    } else {
                        return this.state.dictWord[this.state.openStatus[0]];
                    }
                }
            }, {
                title: dictWord.last_acquisition_date,
                dataIndex: 'displayLatestExecutedDate',
                sortIndex: 'latestExecutedDate',
                sorter: true,
                width: '100px',
            },
        ]
        columns.push({
            title: dictWord.management,
            key: 'action',
            toolTipDisabled: true,
            width: '150px',
            render: (text, record) => (
                <span>
                    <Button variant="contained" color="primary" className={classes.margin} href={'/admin.html#/admin/management/activedirectoryadd/' + record.id} >{this.state.dictWord.modify_record}</Button>
                    <Button variant="contained" color="primary" onClick={this.handleSubmit(record.id)} className={classes.margin}>{this.state.dictWord.delete_record}</Button>
                </span>
            )
        });
        return (
            <div className="mainDom">
                <div className={classes.appBarSpacer} />
                <Grid container direction="row" justify="space-between" alignItems="center" >
                    <Grid item xs={12} md={1}>
                        <label>{dictWord.sever_name}</label>
                    </Grid>
                    <Grid item xs={12} md={2}>

                        <Paper className={classes.inputRoot}>
                            <InputBase
                                className={classes.input}
                                id="serverName"
                                value={this.state.formData.serverName.value}
                                onChange={this.handleChange('serverName')}
                                error={this.state.formData.serverName.error}
                                endAdornment={
                                    <InputAdornment position="end">
                                        {this.state.formData.serverName.value.length > 0 ?
                                            <CloseIcon
                                                color="disabled"
                                                style={{ cursor: 'pointer',width:'18px',height:'18px' }}
                                                onClick={() => {
                                                    let formData = this.state.formData;
                                                    formData['serverName'].value = '';
                                                    this.setState({
                                                        formData,
                                                    });
                                                }}
                                            /> : ''}
                                    </InputAdornment>
                                }
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={1} style={{ textAlign: 'right', paddingRight: '10px' }}>
                        <label>{dictWord.user_id}</label>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Paper className={classes.inputRoot}>
                            <InputBase
                                className={classes.input}
                                id="userId"
                                value={this.state.formData.userId.value}
                                onChange={this.handleChange('userId')}
                                error={this.state.formData.userId.error}
                                endAdornment={
                                    <InputAdornment position="end">
                                        {this.state.formData.userId.value.length > 0 ?
                                            <CloseIcon
                                                color="disabled"
                                                style={{ cursor: 'pointer',width:'18px',height:'18px' }}
                                                onClick={() => {
                                                    let formData = this.state.formData;
                                                    formData['userId'].value = '';
                                                    this.setState({
                                                        formData,
                                                    });
                                                }}
                                            /> : ''}
                                    </InputAdornment>
                                }
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Button variant="contained" color="primary" className={classes.margin} style={{ marginLeft: '40px' }} onClick={this.searchClick}>
                            {dictWord.search}
                        </Button>
                        <Button variant="contained" color="primary" href={'/admin.html#/admin/management/activedirectoryadd'} className={classes.margin}>
                            {dictWord.add_record}
                        </Button>
                    </Grid>
                </Grid>
                <Typography component="div" className={classes.margin}>
                    <CustomizedTable
                        data={this.state.data}
                        columns={columns}
                        count={this.state.pagination.count}
                        page={this.state.pagination.pageNumber}
                        rowsPerPage={this.state.pagination.pageSize}
                        onChange={this.handleTableChange}
                        sord={this.state.pagination.sord}
                        sidx={this.state.pagination.sidx}
                        onSort={this.handleTableSort}
                    />
                </Typography>
                <Dialog
                    open={this.state.dialogOpen}
                    option={{
                        ok: {
                            text: this.state.dictWord['yes'],
                        },
                        close: {
                            text: this.state.dictWord['cancel'],
                        },
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['confirmation']}</DialogTitle>}
                    content={
                        <p>{this.state.dictWord['msg_confirm_really_delete']}</p>
                    }
                    handleOk={this.dialogHandleOK}
                    handleClose={this.dialogHandleClose}
                />
            </div>
        );
    }
}

ActiveDirectory.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(ActiveDirectory);